
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C3 3.44772 3.44772 3 4 3H5.25V6V6.75H6H13H13.75V6V3H15.5858C15.851 3 16.1054 3.10536 16.2929 3.29289L20.7071 7.70711C20.8946 7.89464 21 8.149 21 8.41421V12.8027C20.1175 12.2922 19.0929 12 18 12C16.1052 12 14.4156 12.8783 13.316 14.25H6H5.25V15V21H4C3.44772 21 3 20.5523 3 20V4ZM12.4361 15.75H6.75V21H12.8027C12.2922 20.1175 12 19.0929 12 18C12 17.2043 12.1549 16.4448 12.4361 15.75ZM6.75 5.25V3H9.25V5.25H6.75ZM10.75 5.25V3H12.25V5.25H10.75Z"></path><path d="M20.7049 14.2117L20.3606 14.0503C20.1016 13.9293 19.79 14.034 19.665 14.2856L18.5169 16.5849L18.4484 16.5523C17.8124 16.2555 17.0483 16.5129 16.7417 17.1286L16.6425 17.3274L20.3656 19.0677L20.4648 18.8689C20.7714 18.2532 20.5055 17.5137 19.8694 17.2169L19.8009 17.1852L20.948 14.8859C21.0731 14.6343 20.9649 14.3327 20.7049 14.2117ZM20.2058 19.3856L16.4778 17.6434C16.2505 17.9315 15.9568 18.2561 15.5837 18.5788C15.0131 19.0725 14.4475 19.3981 14 19.6104C14.13 20.008 14.4049 20.1991 14.5984 20.4008C14.6698 20.4757 15.7722 19.3222 15.8516 19.3962C15.931 19.4701 14.9883 20.7706 15.0747 20.8426C15.3317 21.0558 15.6204 21.2595 15.935 21.4506C15.9995 21.49 17.3748 19.6738 17.4363 19.7064C17.5594 19.7717 16.5641 21.7944 16.6941 21.8549C16.8231 21.9154 16.9531 21.9721 17.0821 22.0249C17.5296 22.2074 17.9741 22.3419 18.3998 22.4303C18.5298 22.4571 19.2135 20.1789 19.3385 20.1972C19.4646 20.2154 19.0329 22.5301 19.153 22.5397C19.5152 22.5686 19.8535 22.558 20.1542 22.508C20.05 21.9856 19.9736 21.3113 20.0302 20.5314C20.0619 20.104 20.1284 19.7199 20.2058 19.3856Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowremoveLocalstorageFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
